const AuthTextDescCmp: React.FC<{ text: string; desc: string }> = ({
  text,
  desc,
}) => {
  return (
    <div className="flex flex-col space-y-6 items-start">
      <div className="text-typography-primary text-title-base font-semibold sm:text-display-2xl">
        {text}
      </div>
      <div className="text-text-lg text-[#2d2f34] font-normal text-left">
        {desc}
      </div>
    </div>
  );
};

export default AuthTextDescCmp;
